import {createFetchableSlice} from '../../utils/createFetchableSlice';
import {fetchTenantDetails} from '../../Api';

export const tenantDetailsSlice = createFetchableSlice({
	name: 'tenantDetails',
	fetchable: fetchTenantDetails
});

export default tenantDetailsSlice.reducer;